﻿import { Tooltip } from "components/tooltip";
import { Position } from "@blueprintjs/core";

const assetTypesMappings = [
    { "id": 1, "img": "hgv-scaled.svg", "name": "Heavy Goods Vehicle" },
    { "id": 2, "img": "lcv-scaled.svg", "name": "Light Commercial Vehicle" },
    { "id": 3, "img": "psv-scaled.svg", "name": "Public Service Vehicle" },
    { "id": 4, "img": "trailer-scaled.svg", "name": "Trailer" },
    { "id": 5, "img": "dst-scaled.svg", "name": "Dangerous Substances Tanker" },
    { "id": 6, "img": "crane-scaled.svg", "name": "Crane" },
    { "id": 7, "img": "tail lift-scaled.svg", "name": "Tail Lift" },
    { "id": 8, "img": "lift truck-scaled.svg", "name": "Lift Truck" },
    { "id": 9, "img": "winch-scaled.svg", "name": "Winch" },
    { "id": 10, "img": "hgv-scaled.svg", "name": "Vehicle" },
    { "id": 12, "img": "van-scaled.svg", "name": "Van" },
    { "id": 13, "img": "car-scaled.svg", "name": "Car" },
    { "id": 14, "img": "lifting equipment-scaled.svg", "name": "Lifting Equipment" },
    { "id": 15, "img": "trailer-scaled.svg", "name": "Light Trailer" }
];

const defaultAssetStatusFilters = [{ name: 'ASSETSTATUSID', displayName: 'Active', value: 1 }, { name: 'ASSETSTATUSID', displayName: 'Vehicle Off Road', value: 3 }]

function getVehicleIcon(assetTypeId, assetTypeName, assetTypeSubtypeName) {
    let img = "unknown-vehicle-scaled.svg";
    let vehicleType = assetTypeName || "unknown";
    let subtypeName = assetTypeSubtypeName;
    let assetType = assetTypesMappings.find(o => {
        return o.id === assetTypeId
    });

    if (assetType) {
        img = assetType.img;
        vehicleType = assetType.name;
    }

    const tooltipText = subtypeName
        ? `${vehicleType} - ${subtypeName}`
        : vehicleType;

    return (
        <div className="vehicle-icon">
            <Tooltip position={Position.TOP} content={tooltipText}>
                <img src={`/icons/vehicles/${img}`} alt={vehicleType} />
            </Tooltip>
        </div>
    );
}

function isAssetInactive(assetStatusId, statusList) {
    if (assetStatusId && statusList && statusList.length > 0) {
        let inactiveStatus = statusList.find(s => s.name?.toLowerCase() === "inactive");
        return inactiveStatus?.id === assetStatusId;
    }
    return false;
}

export const AssetHelperFunctions = {
    getVehicleIcon: getVehicleIcon,
    defaultAssetStatusFilters: defaultAssetStatusFilters,
    isAssetInactive: isAssetInactive
};

